import styled from 'styled-components'

export const PickupDetailsModalWrapper = styled.div`
`
export const PickupDetailsModalContentWrapper = styled.div`
    .outer-wrapper{
        hr{
            margin: 15px 10px !important;
        }
        .error-message{
            color: #ff1414 !important;
            font-size: 11px !important;
            margin: 0 !important;
            font-family: 'latoregular' !important;
        }
        .main-header{
            padding: 10px 15px;
            display: flex;
            justify-content: space-between;
            h4{
                font-family: 'latobold';
                font-size: 18px;
            }
            img{
                height: 18px;
                width: 18px;
            }
        }
        .location-details-styles{
            padding: 10px 15px;
            display: grid;
            grid-template-columns: 2fr 2fr;
            gap: 20px;
            p{
                color: #005586;
                font-size: 15px;
                font-family: 'latobold';
                margin-bottom: 2px;
            }
            span{
                font-size: 15px;
                color: #000000;
                font-family: 'latomedium';
            }
        }
        @media (max-width : 710px){
            .location-details-styles{
                grid-template-columns: 1fr 1fr;
            }
        }
        .pickup-details-styles{
            display: grid;
            grid-template-columns: 1fr 1fr 1fr 1fr;
            gap: 20px;
            justify-content: space-between;
            padding: 0px 15px;
            .date-picker-style{
                display: flex;
                align-items: center;
                svg{
                margin: 0px 8px 4px -2px;
                }
            }
            .qty-style{
                display: flex;
                justify-content: space-between;
                position: relative;
                .app-input-text{
                    margin-bottom: 0px !important;
                }
                .error{
                    border: none !important;
                    border-bottom: 1px solid #ef5657 !important;
                }
                input{
                    border: none;
                    border-bottom: 1px solid #cccccc;
                    border-radius: 0px;
                    padding: 0;
                    height: auto;
                    width: 100px !important;
                }
                img{
                    height: 14px;
                    width: 14px;
                    position: absolute;
                    right: 0px;
                    top: 5px;
                    pointer: cursor;
                }
            }
            p{
                color: #005586;
                font-size: 15px;
                font-family: 'latobold';
                margin-bottom: 2px;
            }
            span{
                font-size: 15px;
                color: #000000;
                font-family: 'latomedium';
            }
        }
        @media (max-width : 710px){
            .pickup-details-styles{
                grid-template-columns: 1fr 1fr;
            }
        }
        .pallet-type-styles{
            padding: 0px 15px;
            .header, .content-rows{
                display: grid;
                grid-template-columns: 2fr 2fr;
                gap: 20px;
            }
            .content-rows{
                margin-bottom: 5px;
                .css-g1d714-ValueContainer{
                  padding: 0px;
                }
                .app-input-text{
                  input{
                    padding: 0px;
                  }
                }
                .add-button{
                    border: none;
                    background: #004A79;
                    padding: 0 0 2px 1px;
                    height: 32px;
                    width: 32px;
                    border-radius: 2px;
                    svg{
                      margin: 0 !important;
                    }
                }
                .delete-button{
                    border: none;
                    background: transparent;
                    padding: 0 0 2px 1px;
                    height: 37px;
                    border-radius: 2px;
                }
                .total-qty-style{
                    font-size: 15px;
                    font-family: 'latobold';
                }
                .app-input-text{
                    margin-bottom: 0px !important;
                    input{
                        border: none;
                        border-bottom: 1px solid #cccccc;
                        border-radius: 0px;
                    }
                    .error{
                        border: none !important;
                        border-bottom: 1px solid #f47b7b !important;
                        border-radius: 0px !important;
                    }
                }
                .css-yk16xz-control{
                    border: none;
                    border-bottom: 1px solid #cccccc;
                    border-radius: 0px;
                }
                .css-1okebmr-indicatorSeparator{
                    display: none;
                }
            }
            .selcted-pallets-styles{
                input{
                    background: #E7E7E7;
                    border: none;
                    padding: 8px 10px;
                    font-size: 14px;
                    max-width: 210px;
                    font-family: 'latomedium';
                    color: #292929;
                }
            }
            p{
                color: #005586;
                font-family: 'latobold';
                font-size: 15px;
            }
            h6{
                font-size: 14px;
                margin: 10px 0;
                font-family: 'latobold';
                span{
                    font-family: 'latoregular';
                }
            }
        }
        .bol-pickupDate-row{
            padding: 0px 15px;
            display: flex;
            justify-content: space-between;
            margin-top: 25px;
            gap: 30px;       
            p{
                color: #005586;
                font-family: 'latobold';
                font-size: 15px;
            }
            .MuiFormControl-root{
                border: none;
                border-bottom: 1px solid #ccc;
                border-radius: 0px;
                height: 35px;
            }
            .MuiInput-root{
                padding: 0;
            }   
        }
        .comment-section-style{
            padding: 0px 15px;
            p{
                color: #005586;
                font-family: 'latobold';
                font-size: 15px;
            }
            textarea{
                border: 1px solid #cccc !important;
                height: 50px;
            }
            .app-input-text{
              margin-bottom: 10px;
            }
        }
        .uploaded-files-styles{
            padding: 0px 15px;
            margin-bottom: 15px;
            p{
                color: #005586;
                font-family: 'latobold';
                font-size: 15px;
            }
            .files-list{
                display: flex;
                flex-direction: column;
                gap: 6px;
                span{
                    font-size: 13px;
                    border-bottom: 1px solid #676767;
                    width: fit-content;
                    cursor: pointer;
                }
            }
        }
        .checkbox-section-style{
            padding: 0px 15px;
            .checkbox-container{
                font-size: 14px !important;
            }
        }
        .claim-type-section{
            padding: 0px 15px;
            margin: 25px 0;
            p{
                color: #005586;
                font-family: 'latobold';
                font-size: 15px;
            }
            .check-box-wrapper{
                display: grid;
                grid-template-columns: 3fr 2fr 0.5fr;
                gap: 10px;
                margin-bottom: 15px;
                .checkbox-field{
                    margin: 0px !important;
                }
                .checkbox-container{
                    font-size: 14px !important;
                }
                .checkMark {
                    height: 19px !important;
                    width: 19px !important;
                }
                .checkMark:after{
                    left: 5px !important;
                }
            }
        }
        .claim-acknowledge-style{
          p{
            font-size: 15px;
            font-family: 'latomedium';
            padding: 0 15px;
            margin-bottom: 20px;
          }
        }
        .submit-button{
            justify-content: center;
            display: flex;
            margin-bottom: 5px;
            button{
                cursor: pointer;
                background: linear-gradient(90deg, #55C416 0%, #367910 100%);
                color: #fff;
                border: none;
                height: 35px;
                padding: 0 20px;
                border-radius: 5px;
                &:disabled {
                    opacity: 0.5;
                }
            }
        }
        @media (max-width: 500px) {
          .bol-pickupDate-row{
            display: grid;
          }
        }
    }
`

export const CancelOrRescheduleModalWrapper = styled.div`
`
export const CancelOrRescheduleModalContentWrapper = styled.div`
    .outer-wrapper{
        padding: 10px 15px;
        .date-class{
            color: #005586;
            font-family: 'latobold';
            span{
                color: #000;
                font-family: 'latoregular';
                margin-left: 5px;
            }            
        }
        .main-header{
            display: flex;
            justify-content: space-between;
            h4{
                font-family: 'latobold';
                font-size: 18px;
            }
            img{
                height: 18px;
                width: 18px;
            }
        }
        .radio-selection-section{
            display: flex;
            margin-top: 20px;
        }
        .reschedule-details-section{
            display: flex;
            justify-content: space-between;
            gap: 10px;
            margin: 10px 0;
            .error-message{
                color: #ff1414 !important;
                font-size: 11px !important;
                margin: 0 !important;
                font-family: 'latoregular' !important;
            }
            .app-window-style{
                display: flex;
                justify-content: space-between;
                gap: 10px;
                .toStyle{
                    display: flex;
                    align-items: center;
                }
                .app-input-text {
                    margin: 0px !important;
                }
                input{
                    height: 43px !important;
                }
            }

        }
        .comment-section-style{
            p{
                color: #005586;
                font-family: 'latobold';
                font-size: 15px;
            }
            textarea{
                border: 1px solid #cccc !important;
            }
        }
        .submit-button{
            justify-content: center;
            display: flex;
            margin-bottom: 5px;
            button{
                cursor: pointer;
                background: linear-gradient(90deg, #55C416 0%, #367910 100%);
                color: #fff;
                border: none;
                height: 35px;
                padding: 0 20px;
                border-radius: 5px;
                &:disabled {
                    opacity: 0.5;
                }
            }
        }
    }
`

export const RetryModalContentWrapper = styled.div`
    .outer-wrapper{
        padding: 10px 15px;
        .no-pay-styles{
            margin: 20px 0;
            span{
                color: #007bff;
                cursor: pointer;
            }
        }
        .main-header{
            display: flex;
            justify-content: space-between;
            h4{
                font-family: 'latobold';
                font-size: 18px;
            }
            img{
                height: 18px;
                width: 18px;
            }
        }
        .content-wrapper{
            padding-top: 30px;
            .radioField{
                margin-bottom: 5px;
            }
        }
        .submit-button{
            justify-content: center;
            display: flex;
            margin-bottom: 5px;
            margin-top: 10px;
            justify-content: center;
            button{
                cursor: pointer;
                background: linear-gradient(90deg, #55C416 0%, #367910 100%);
                color: #fff;
                border: none;
                height: 35px;
                padding: 0 20px;
                border-radius: 5px;
                &:disabled {
                    opacity: 0.5;
                }
            }
        }
    }
    .add-new-styles{
        font-size: 13px;
        span{
            color: #007bff;
            cursor: pointer;
        }
    }
`